/**
 * A component this build has never heard of.
 *
 * The graph is free to ship a new card before the frontend can draw it — the
 * text answer is self-sufficient by contract, so a missing card is not a missing
 * answer. If the props carry something readable we show it; if they do not, we
 * draw nothing at all rather than an empty frame that looks broken.
 */

export default function UnknownCard({ props }: { props: unknown }) {
  const record = props && typeof props === 'object' ? (props as Record<string, unknown>) : {};
  const title = typeof record.title === 'string' ? record.title : null;
  const text = typeof record.text === 'string' ? record.text : null;
  if (!title && !text) return null;
  return (
    <article className="card card--unknown">
      <div className="card__pad">
        {title ? <h3 className="card__title">{title}</h3> : null}
        {text ? <p className="card__text">{text}</p> : null}
      </div>
    </article>
  );
}
